import { DebounceStack } from '../helpers/debounce-stack';
import { updateCart, cartState } from './cart.service';
export const dialogStack = new DebounceStack(100);
dialogStack.addListener((stack) => {
    console.log('dialogStack listener', stack);
    const lastPopup = stack[stack.length - 1];
    if (!stack.length) {
        csqArtificialPageview('close', lastPopup);
    }
    else {
        csqArtificialPageview('open', lastPopup);
    }
});
/**
 * used to track page views in SPA
 */
export function trackPageView(route) {
    if (!route) {
        console.warn('route not defined; unable to track page view');
    }
    else {
        if (window.ga) {
            window.ga('set', 'page', route);
            window.ga('send', 'pageview');
        }
    }
}
export function emitShopifyEvent(name, payload = {}) {
    console.debug("emitting shopify event", name, payload);
    window.Shopify?.analytics?.publish(name, payload);
}
function updateCartAttributesIfChanged(attributes) {
    const existing = cartState.get()?.attributes ?? {};
    const hasChange = Object.entries(attributes).some(([key, value]) => existing[key] !== value);
    if (!hasChange) {
        return;
    }
    updateCart({ attributes });
}
export function attachSessionIdsToCart() {
    const pendingSessionAttributes = {};
    const flushSessionAttributes = () => {
        if (!Object.keys(pendingSessionAttributes).length) {
            return;
        }
        updateCartAttributesIfChanged({ ...pendingSessionAttributes });
    };
    getCSQGlobal().push(["getSessionKey", {
            callback: (sessionKey) => {
                if (sessionKey) {
                    pendingSessionAttributes._csq_session_key = sessionKey;
                    flushSessionAttributes();
                }
            }
        }]);
    getCSQGlobal().push(["replay:link:generate", { withTimestamp: false }, (context) => {
            if (context.replayLink) {
                pendingSessionAttributes._csq_session_replay_link = context.replayLink;
                flushSessionAttributes();
            }
        }]);
}
/**
 * returns the Content Square global object. If it doesn't exist, it initializes it as an empty array.
 * @see: https://docs.contentsquare.com/en/web/#the-_uxa-object
 * @returns
 */
export function getCSQGlobal() {
    return window._uxa = window._uxa || [];
}
/**
 * Sends a custom page event to Contentsquare.
 * Use for binary presence signals (e.g. "did this page have feature X").
 * @see https://docs.contentsquare.com/en/web/custom-page-events/
 */
export function csqTrackPageEvent(eventName) {
    getCSQGlobal().push(['trackPageEvent', eventName]);
}
/**
 * Resolves the Contentsquare session replay URL for the current session.
 * @see https://docs.contentsquare.com/en/web/command-reference/#replaylinkgenerate
 */
export function generateCSQReplayLink(withTimestamp = true) {
    return new Promise((resolve) => {
        getCSQGlobal().push(['replay:link:generate', { withTimestamp }, (context) => {
                resolve(context.replayLink || null);
            }]);
    });
}
/**
 * Sends a dynamic variable to Contentsquare for session segmentation.
 * Unlike custom variables, dynamic variables can be sent at any point without requiring a pageview.
 * Strings support regex matching; numbers support range operators in the CS app.
 * @see https://docs.contentsquare.com/en/web/sending-dynamic-vars/
 */
export function csqTrackDynamicVariable(key, value) {
    getCSQGlobal().push(['trackDynamicVariable', { key, value }]);
}
/**
 * Sends an artificial pageview to Contentsquare for tracking modals/popups
 * @see: https://docs.contentsquare.com/en/web/artificial-pageviews/#tracking-a-modal-opening
 * @param action - The action to track ("open" or "close")
 * @param popupIdentifier - The identifier for the popup (e.g., "quickshop", "inline-cart", "size-guide", "post-add-to-cart")
 */
export function csqArtificialPageview(action, popupIdentifier) {
    const _uxa = getCSQGlobal();
    console.log("csqArtificialPageview", action, popupIdentifier);
    if (action === "open") {
        _uxa.push([
            "setQuery",
            window.location.search + (window.location.search ? "&" : "?") + `${popupIdentifier}`,
            { lifespan: 'onNextPageviewOnly' }
        ]);
        _uxa.push([
            "trackPageview",
            window.location.pathname + window.location.hash.replace("#", "?__"),
            { lifespan: 'onNextPageviewOnly' }
        ]);
    }
    else {
        _uxa.push([
            "trackPageview",
            window.location.pathname + window.location.hash.replace("#", "?__")
        ]);
    }
}
